export class OfflineKioskStatusChartItemModel {
    public date: any;
    public count: number;
}

export class OfflineKioskStatusChartModel {
    public kioskLogs: Array<OfflineKioskStatusChartItemModel>;
    public callMachineLogs: Array<OfflineKioskStatusChartItemModel>;
}
